import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	mappingModalCurrentPriorityHeading: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-view.mapping-list.mapping-modal-current-priority-heading',
		defaultMessage: 'Current priority',
		description: 'title for mapping modal table current priority header',
	},
	mappingModalNewPriorityHeading: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-view.mapping-list.mapping-modal-new-priority-heading',
		defaultMessage: 'New priority',
		description: 'title for mapping modal table new priority header',
	},
	mappingTableArrowIcon: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-view.mapping-list.mapping-table-arrow-icon',
		defaultMessage: 'chevron left to right icon',
		description:
			'icon label pointing left to right to indicate the priority is being mapped from to the left priority to the right priority',
	},
	mappingModalDropdownMenuTitle: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-view.mapping-list.mapping-modal-dropdown-menu-title',
		defaultMessage: 'Select priority',
		description: 'Dropdown menu title for selecting a priority when mapping',
	},
});

export default messages;
